import { render } from "./HomeStart.vue?vue&type=template&id=30e44ff5"
import script from "./HomeStart.vue?vue&type=script&lang=js"
export * from "./HomeStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__